import React from "react";
import {useTranslation} from "react-i18next";
import {StatementSummary} from "../../../models/accounting/statements";
import {Col, Row} from "antd";
import {InfoBlock} from "../../core/commons/info-block/info-block";
import {Date} from "../../core/commons/date/date";
import {Price} from "../../core/commons/price/price";
import {Explanation} from "../../core/commons/explanation/explanation";

interface StatementsListInfoProps {
    summary: StatementSummary;
}

export const StatementsListInfo: React.FC<StatementsListInfoProps> = ({summary}) => {

    const {t} = useTranslation("translation", {useSuspense: false});

    return (
        <Row gutter={[15, 15]}>
            <Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                <InfoBlock title={<>
                    {t("STATEMENTS.SUMMARY.ENDING_BALANCE.TITLE")} at <Date dateString={summary.onDate} />
                </>}>
                    <Explanation
                        title={<Price
                            value={{value: summary.balance, currencyCode: summary.currencyCode as any}}
                        />}
                        tooltip={t("STATEMENTS.SUMMARY.ENDING_BALANCE.HINT")}
                    />
                </InfoBlock>
            </Col>
            <Col xxl={8} xl={8} lg={8} md={8} sm={8} xs={24}>
                <InfoBlock title={t("STATEMENTS.SUMMARY.INVOICES_BALANCE.TITLE")} small>
                    <Explanation
                        title={<Price
                            value={{value: summary.invoicesBalance, currencyCode: summary.currencyCode as any}}
                        />}
                        tooltip={t("STATEMENTS.SUMMARY.INVOICES_BALANCE.HINT")}
                    />
                </InfoBlock>
            </Col>
            <Col xxl={8} xl={8} lg={8} md={8} sm={8} xs={24}>
                <InfoBlock title={t("STATEMENTS.SUMMARY.CREDIT_INVOICES_BALANCE.TITLE")} small>
                    <Explanation
                        title={<Price
                            value={{value: summary.creditInvoicesBalance, currencyCode: summary.currencyCode as any}}
                        />}
                        tooltip={t("STATEMENTS.SUMMARY.CREDIT_INVOICES_BALANCE.HINT")}
                    />
                </InfoBlock>
            </Col>
            <Col xxl={8} xl={8} lg={8} md={8} sm={8} xs={24}>
                <InfoBlock title={t("STATEMENTS.SUMMARY.UNALLOCATED_FUNDS.TITLE")} small>
                    <Explanation
                        title={<Price
                            value={{value: summary.freeBalance, currencyCode: summary.currencyCode as any}}
                        />}
                        tooltip={t("STATEMENTS.SUMMARY.UNALLOCATED_FUNDS.HINT")}
                    />
                </InfoBlock>
            </Col>
        </Row>
    )
}